import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Post from '../newsline/post';


class PostsList extends Component {

    constructor(props) {
        super(props);
        this.props = props
        this.state = {
            showImageModal: false
        }
    }

    render() {
        const { posts } = this.props;
        return (
            <div className="post-list-container">
                {
                    posts && posts.map((item, key) => (
                        <Post item={item} key={key} deletePost={this.props.deletePost} doUpdatePost={this.props.doUpdatePost} history={this.props.history}/>
                    ))
                }
            </div>
        )
        // }
    }
}
PostsList.propTypes = {
    history: PropTypes.object,
    posts: PropTypes.array,
    deletePost: PropTypes.func,
    doUpdatePost: PropTypes.func
};

export default PostsList;



// WEBPACK FOOTER //
// ./src/components/newsline/postsList.js